import axios from "axios";
import { apiUrl } from "../../App";

export async function excludeUserFromCommunityRankingsUseCase(
  communityId: string,
  userId: string
) {
  return await axios.post(
    `${apiUrl}/admin/rankings/excluded-user`,
    { communityId, userId },
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
      },
    }
  );
}
